import cn from 'bem-cn';

import { Skeleton, Stack } from '../UI';

import './ChallengeCard.scss';

const b = cn('challenge');
const bSkeleton = cn('challenge-skeleton');

export const ChallengeCardSkeleton = () => {
    return (
        <Stack className={bSkeleton()}>
            <Stack direction="row" className={bSkeleton('header')}>
                <Skeleton variant="rounded" className={bSkeleton('badge')} />
                <Stack className={bSkeleton('deadline')}>
                    <Skeleton variant="text" />
                    <Skeleton variant="text" width="80%" />
                </Stack>
            </Stack>
            <Stack spacing={8} className={b('title')}>
                <Skeleton variant="text" />
                <Skeleton variant="text" width="60%" />
            </Stack>
        </Stack>
    );
};
